export default __webpack_public_path__ + "static/media/money.5eb9a51f.svg";